import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItsOkay = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 6.5,
			r: 5.00808,
			fill: "#28C07B",
			stroke: "#A6E9C8",
			strokeWidth: 1.01616
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.58176 6.71884C4.68665 6.67688 4.80569 6.7279 4.84764 6.83279L4.65772 6.90875C4.84764 6.83279 4.84768 6.83289 4.84764 6.83279L4.84748 6.83238L4.84943 6.83682C4.85162 6.84173 4.85545 6.85002 4.86105 6.86122C4.87226 6.88364 4.89049 6.91754 4.91682 6.95911C4.96958 7.04241 5.0541 7.15537 5.17884 7.26876C5.42499 7.49253 5.83695 7.72693 6.49863 7.72693C7.16032 7.72693 7.57228 7.49253 7.81843 7.26876C7.94316 7.15537 8.02769 7.04241 8.08045 6.95911C8.10678 6.91754 8.12501 6.88364 8.13622 6.86122C8.14182 6.85002 8.14564 6.84173 8.14784 6.83682L8.14991 6.83207C8.14996 6.83195 8.15006 6.83172 8.14991 6.83207C8.192 6.72743 8.31075 6.67693 8.41551 6.71884C8.5204 6.76079 8.57141 6.87983 8.52946 6.98472L8.33954 6.90875C8.52946 6.98472 8.52951 6.9846 8.52946 6.98472L8.52902 6.9858L8.52842 6.98727L8.52674 6.99131C8.5254 6.99448 8.52361 6.99862 8.52136 7.00366C8.51686 7.01373 8.5105 7.02741 8.50212 7.04417C8.48537 7.07768 8.46045 7.12369 8.42605 7.178C8.35736 7.28646 8.25013 7.42918 8.09361 7.57147C7.77726 7.85906 7.26877 8.13602 6.49863 8.13602C5.7285 8.13602 5.22001 7.85906 4.90366 7.57147C4.74714 7.42918 4.63991 7.28646 4.57121 7.178C4.53682 7.12369 4.5119 7.07768 4.49515 7.04417C4.48677 7.02741 4.48041 7.01373 4.47591 7.00366C4.47366 6.99862 4.47187 6.99448 4.47053 6.99131L4.46884 6.98727L4.46825 6.9858L4.46801 6.98521C4.46796 6.98509 4.46781 6.98472 4.65772 6.90875L4.46781 6.98472C4.42585 6.87983 4.47687 6.76079 4.58176 6.71884Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.27237,
			cy: 5.68155,
			r: .409091,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.7255,
			cy: 5.68155,
			r: .409091,
			fill: "white"
		})
	]
});
export default SvgItsOkay;
